import React, { useEffect, useRef, useState } from "react";
import { FormCard, FormHeader } from "../../../components/FormCard/FormCard";
import InputBox from "../../../components/Inputbox/InputBox";
import { Radio, Radio2 } from "../../../components/Radio/Radio";
import ReCAPTCHAV2 from "react-google-recaptcha";
import "./regDeveloper.scss";
import Button from "../../../components/Button/Button";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { Scrollbars } from "react-custom-scrollbars";
import { encryptStorage } from "../../../helper/storage";
import AnimatedModal from "../../../components/Modal/AnimatedModal";
import Loading from "../../../components/Loading/Loading";
import { transparentInfoIcon } from "../../../helper/icons";
import axios from "axios";
import { API_URL } from "../../../helper/request";
import { useHistory } from "react-router-dom";
import PhoneInputBox from "../../../components/PhoneInputBox/PhoneInputBox";
import { LoadingText } from "../register/AuthRegister";
import { useDebouncedEffect } from "../../../helper/useDebounce";
import { notify } from "../../../Routes";
const radios = ["Freelancer", "Student", "Company"];
const develop = ["Usecase", "AI Model", "IOT Firmware"];
let msg = {
  type: "alert",
  header: "Error",
  errorText: "Something Went Wrong",
};
let timeout = null;
let firstLoad = true;
export default function AuthRegisterDeveloper() {
  const scrollbarRef = useRef();
  const history = useHistory();
  const [ShowAlert, setShowAlert] = useState(false);
  const [ShowBank, setShowBank] = useState(false);
  const [LoadingScreen, setLoadingScreen] = useState(false);
  const [Role, setRole] = useState(null);
  const [CompanyName, setCompanyName] = useState("");
  const [SocialLinks, setSocialLinks] = useState([...social_link]);
  const [Develop, setDevelop] = useState([]);
  const [Bank, setBank] = useState({});
  const [Name, setName] = useState("");
  const [Phone, setPhone] = useState("");
  const [Country, setCountry] = useState("");
  const [LocationLoading, setLocationLoading] = useState(false);
  const [LocationData, setLocationData] = useState([]);
  const [TOS, setTOS] = useState(false);
  const [AllSMSelected, setAllSMSelected] = useState(false);
  const [captchaValue, setcaptchaValue] = useState("");

  useDebouncedEffect(
    () => (Country ? getCountry() : undefined),
    [Country],
    1000
  );

  const getCountry = () => {
    if (firstLoad) return;
    axios
      .get(API_URL + "admin/country/filters?country=" + Country)
      .then((res) => {
        let _data = res.data.detail;
        let keys = null;
        keys = Object.keys(_data[0]);
        if (!keys?.includes("state")) {
          setLocationData(_data);
        } else {
          setLocationData([]);
          getBank(Country);
        }
      })
      .catch((err) => {
      })
      .finally(() => {
        setLocationLoading(false);
      });
  };

  const handleSocialClick = (idx) => {
    let _data = [...SocialLinks];
    _data[idx].isOpen = true;
    setSocialLinks([..._data]);
  };
  const handleSocialDelete = (idx) => {
    let _data = [...SocialLinks];
    _data[idx].isOpen = false;
    _data[idx].link = "";
    setSocialLinks([..._data]);
  };

  const handleFocus = (name) => {
    let ele = document.getElementById(name);
    ele.classList.remove("error_shake", "input__error");
  };

  const validateBankData = () => {
    let res = false;
    for (let i = 0; i < Bank.fields.length; i++) {
      if (Bank.fields[i].required) {
        if (!Bank.fields[i].value) {
          let ele = document.getElementById(Bank.fields[i].name);
          ele.classList.add("error_shake", "input__error");
          res = true;
        }
      }
    }
    return res;
  };

  const getKeyCode = (e) => {
    switch (e.keyCode) {
      case 38:
        arrowKey(e, "up");
        break;

      case 40:
        arrowKey(e, "down");
        break;

      case 13:
        enterKey(e);
        break;
    }
  };

  const arrowKey = (e, type) => {
    let myReferenceDiv = document.querySelector("._span");
    let active_flag = document.querySelector(".active_flag");
    let active_next = active_flag?.nextElementSibling;
    let active_prev = active_flag?.previousElementSibling;
    let next = myReferenceDiv?.nextElementSibling;
    let prev = myReferenceDiv?.previousElementSibling;
    if (type === "down") {
      if (!active_flag) {
        next.classList.add("active_flag");
      } else {
        if (active_next) {
          active_flag.classList.remove("active_flag");
          active_next.classList.add("active_flag");
          var childElement =
            document.querySelector(".active_flag").offsetTop -
            myReferenceDiv.offsetHeight -
            20;
        }
      }
    }
    if (type === "up") {
      if (active_prev && !active_prev.classList.contains("_span")) {
        active_flag.classList.remove("active_flag");
        active_prev.classList.add("active_flag");
        var childElement =
          document.querySelector(".active_flag").offsetTop -
          myReferenceDiv.offsetHeight -
          20;
      }
    }
  };

  const enterKey = () => {
    let active_flag = document.querySelector(".active_flag");
    let dataCountry = active_flag.getAttribute("data-country");
    if (dataCountry) {
      setCountry(dataCountry);
      getBank(dataCountry);
      setLocationData([]);
    }
  };

  const postData = () => {
    let error = false;
    let _mobile = Phone.split(" ")[1];

    if (!TOS) {
      error = true;
      notify({
        msg: "Please accept our Terms of Service.",
      });
      // msg.errorText = "Please accept out Terms of Service.";
      // msg.header = "Error";
      // msg.type = "alert";
      // handleAlert(true, msg);
      // setShowAlert(true);
      // return;
    }

    if (!Role || Develop.length == 0) {
      if (!Role) {
        document.getElementById("_role").style.border =
          "2px solid rgba(248, 78, 78, 0.7)";
        document.getElementById("_role").style.padding = "5px";
        document.getElementById("_role").style.marginBottom = "0.8vw";
      }
      if (Develop.length == 0) {
        document.getElementById("_like").style.border =
          "2px solid rgba(248, 78, 78, 0.7)";
        document.getElementById("_like").style.padding = "5px";
        document.getElementById("_like").style.marginBottom = "0.8vw";
      }
      error = true;
    }
    if (ShowBank) {
      if (!Name) {
        document
          .getElementById("fullName")
          .classList.add("error_shake", "input__error");
        error = true;
      }
      if (!_mobile) {
        document
          .getElementById("mobile_number")
          .classList.add("error_shake", "input__error");
        error = true;
      }
      if (!Country) {
        document
          .getElementById("country")
          .classList.add("error_shake", "input__error");
        error = true;
      }
      if (validateBankData()) {
        error = true;
      }
    }

    // if (captchaValue === "") {
    //   error = true;
    //   notify({
    //     msg: "Captcha validation is required",
    //   });
    // }

    if (error) return;

    let lData = encryptStorage.getItem("DDATA");
    // let _uname = lData?.userData?.Username;
    let _sLink = {};
    SocialLinks.forEach((element) => {
      if (element.isOpen) {
        _sLink[element.name.toLowerCase()] = element.link;
      }
    });

    let body = {
      profession: Role,
      company_name: CompanyName,
      interested_areas: Develop,
      social_media: { ..._sLink },
    };

    if (ShowBank) {
      let _bank = {};
      for (let i = 0; i < Bank.fields.length; i++) {
        _bank[Bank.fields[i].name] = Bank.fields[i].value;
      }
      body.contact_person_name = Name;
      body.contact_person_phone = Phone;
      body.country = Country;
      body.bank_details = { ..._bank };
    }
    setLoadingScreen(true);
    axios
      .post(API_URL + "user/signup/developer?user_name=" + lData.username, body)
      .then((res) => {
        msg.errorText = "Registered as developer successfully!";
        msg.header = "Success";
        msg.type = "success";
        setShowAlert(true);
        timeout = setTimeout(() => {
          encryptStorage.removeItem("DDATA");
          history.push("/");
        }, 3000);
      })
      .catch((err) => {
        msg.errorText = "Failed to save data!";
        msg.header = "Error";
        msg.type = "alert";
        setShowAlert(true);
      })
      .finally(() => {
        setLoadingScreen(false);
      });
  };

  const renderElement = (item, idx) => {
    switch (item.type) {
      case "string":
      case "number":
        return (
          <InputBox
            id={item.name}
            header={item.name.replace(/_/g, " ")}
            onChange={(e) => {
              const value =
                item.type === "string"
                  ? e.target.value
                  : e.target.value.replace(/[^0-9]/g, "");
              handleChanges(value, idx);
            }}
            value={item.value}
            onFocus={() => handleFocus(item.name)}
          />
        );
      case "dropdown":
        return (
          <Dropdown
            label={item.name.replace(/_/g, " ")}
            className="adjust_dd"
            id={item.name}
            optionsList={item.options}
            handleOption={(data) => {
              handleChanges(data, idx);
              handleFocus(item.name);
              // setAccountType(data);
            }}
            defaultText={item.value}
            // error={BankError["isAccountTypeEmpty"]}
          />
        );
      default:
        return <p> NO ELEMENT FOUNG</p>;
    }
  };

  const handleChanges = (value, idx) => {
    const _bank = { ...Bank };
    _bank.fields[idx].value = value;
    setBank({ ..._bank });
  };

  const getBank = (country) => {
    setLoadingScreen(true);
    axios
      .get(API_URL + "admin/bank/details?country=" + country)
      .then((res) => {
        setShowBank(true);
        let dict = { ...res.data };
        for (let i = 0; i < dict.fields.length; i++) {
          dict.fields[i].value = "";
        }
        setCountry(country);
        setBank({ ...dict });
      })
      .catch((err) => {
        setShowBank(false);
        setBank({});
      })
      .finally(() => {
        setLoadingScreen(false);
        setTimeout(() => {
          firstLoad = false;
        }, 2000);
      });
  };

  useEffect(() => {
    let arr = SocialLinks.map((item) => item.isOpen);
    if (arr.every((item) => item === true)) {
      setAllSMSelected(true);
    } else {
      setAllSMSelected(false);
    }
    scrollbarRef.current && scrollbarRef.current.scrollToBottom();
  }, [SocialLinks]);

  useEffect(() => {
    let eData = encryptStorage.getItem("DDATA");

    // eData = {
    //   country: "India",
    //   phone: "+91 7208555614",
    // };
    if (!eData) {
      history.push("/");
      return;
    }
    setPhone(eData.phone);
    getBank(eData.country);
    return () => {
      firstLoad = true;
    };
  }, []);

  return (
    <div className="__auth_reg_developer__ light-theme">
      <FormCard>
        <div style={{ paddingRight: "2vw" }}>
          <FormHeader name="Sign up to Become a" bold="Developer." />
          <p className="sub">Develop a solution for the world with us.</p>
          <Scrollbars
            renderThumbHorizontal={({ style, ...props }) => {
              const thumbStyle = {
                borderRadius: 6,
                backgroundColor: "rgba(35, 49, 86, 0.8)",
              };
              return <div style={{ ...style, ...thumbStyle }} {...props} />;
            }}
            renderThumbVertical={({ style, ...props }) => {
              const thumbStyle = {
                borderRadius: 6,
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                width: "3px",
              };
              return <div style={{ ...style, ...thumbStyle }} {...props} />;
            }}
            autoHeight
            autoHeightMax="50vh"
          >
            <div style={{ paddingRight: "0.8vw" }}>
              <div
                style={{
                  borderRadius: "12px",
                  display: "inline-block",
                }}
                id="_role"
              >
                <span className="radio-header _star">
                  Currently, what are you doing?{" "}
                </span>
                <div
                  style={{
                    display: "flex",
                    gap: "2.5vw",
                    marginBottom: "1.2vw",
                    marginTop: "0.625vw",
                  }}
                >
                  {radios.map((item) => (
                    <Radio2
                      checked={Role === item}
                      name={item}
                      key={item}
                      onClick={() => {
                        document.getElementById("_role").style.border = "0";
                        document.getElementById("_role").style.padding = "0px";

                        // if (errors.isRoleEmpty) {
                        //   setErrors((prev) => {
                        //     return {
                        //       ...prev,
                        //       isRoleEmpty: false,
                        //     };
                        //   });
                        // }
                        setRole(item);
                      }}
                    />
                  ))}
                </div>
              </div>
              <InputBox
                id="companyName"
                header="Company name"
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^[a-zA-Z ]*$/;
                  if (value.match(regex) || value === "") {
                    setCompanyName(value);
                  }
                }}
                // error={errors["isDevelopEmpty"]}
                value={CompanyName}
                // onFocus={() => clearError("isDevelopEmpty")}
              />
              <div
                id="_like"
                style={{
                  borderRadius: "12px",
                  display: "inline-block",
                }}
                onClick={() => {
                  document.getElementById("_like").style.border = "0";
                  document.getElementById("_like").style.padding = "0px";
                  document.getElementById("_like").style.marginBottom = "0px";
                }}
              >
                <span className="radio-header _star">
                  What would you like to develop?
                </span>
                <div
                  style={{
                    display: "flex",
                    gap: "2.5vw",
                    marginBottom: "1.2vw",
                    paddingLeft: "4px",
                    marginTop: "0.625vw",
                  }}
                >
                  {develop.map((item, indx) => (
                    <Radio
                      key={item}
                      name={item}
                      id={"dev_" + indx}
                      checked={Develop.includes(item)}
                      onClick={() => {
                        let _develop = [...Develop];
                        if (_develop.includes(item)) {
                          const index = _develop.indexOf(item);
                          if (index > -1) {
                            _develop.splice(index, 1);
                          }
                        } else {
                          _develop.push(item);
                        }

                        setDevelop([..._develop]);
                      }}
                      className="adjust_cbb"
                    />
                  ))}
                </div>
              </div>
              <div className="social_links_wrapper">
                <div className="radio-header _flex">
                  <p>Social Media</p>
                  {!AllSMSelected && (
                    <div className="fab">
                      <div className="mainop">{add()}</div>
                      <div className="minifab" style={{ width: "35px" }} />
                      {SocialLinks.map((item, index) => {
                        if (!item.link && !item.isOpen) {
                          return (
                            <div
                              key={item.name}
                              className="minifab"
                              onClick={() => handleSocialClick(index)}
                            >
                              {item.icon}
                            </div>
                          );
                        }
                        return null;
                      })}
                    </div>
                  )}
                </div>
                <Scrollbars autoHeight autoHeightMax="10vh" ref={scrollbarRef}>
                  <div style={{ padding: "0.5vw 0", paddingRight: "0.2vw" }}>
                    {SocialLinks.map((item, index) => {
                      if (item.isOpen) {
                        return (
                          <SocialInput
                            key={item.name}
                            icon={item.icon}
                            onDelete={() => handleSocialDelete(index)}
                            onChange={(e) => {
                              let _sLink = [...SocialLinks];
                              _sLink[index].link = e.target.value;
                              setSocialLinks([..._sLink]);
                            }}
                            value={SocialLinks[index].link}
                          />
                        );
                      }
                      return null;
                    })}
                  </div>
                </Scrollbars>
              </div>
              <div className="country_section">
                <InputBox
                  id="country"
                  header="Country"
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^[a-zA-Z ]*$/;
                    if (value.match(regex) || value === "") {
                      setCountry(value);
                      setLocationLoading(true);
                    } else {
                      setLocationLoading(false);
                    }
                  }}
                  onKeyDown={getKeyCode}
                  // error={errors["isCountryEmpty"]}
                  value={Country}
                  // onFocus={() => clearError("isCountryEmpty")}
                />
                {LocationLoading && Country ? (
                  <div className="suggestions">
                    <LoadingText />
                  </div>
                ) : (
                  LocationData.length > 0 && (
                    <div className="suggestions">
                      <Scrollbars autoHeight autoHeightMax="15vh">
                        <span className="_span" />
                        {LocationData.map((item) => (
                          <div
                            key={item.country}
                            className="suggestion_item"
                            data-country={item.country}
                            onClick={() => {
                              setCountry(item.country);
                              setLocationData([]);
                              getBank(item.country);
                            }}
                          >
                            {item.country}
                          </div>
                        ))}
                      </Scrollbars>
                    </div>
                  )
                )}
              </div>
              {ShowBank && (
                <React.Fragment>
                  <div style={{ marginTop: "1vw" }} />
                  <div className="contact_person">
                    <span className="fc-header">Contact Person</span>
                    <div className="bank_detail">
                      <InputBox
                        id="fullName"
                        header="Name"
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^[a-zA-Z ]*$/;
                          if (value.match(regex) || value === "") {
                            setName(value);
                          }
                        }}
                        value={Name}
                        onFocus={() => handleFocus("fullName")}
                      />
                      <PhoneInputBox
                        id="mobile_number"
                        isEdit={true}
                        onChange={(data) => {
                          // if (data.inputNumber) {
                          let _number =
                            data.countryCode + " " + data.inputNumber;
                          setPhone(_number);
                          // }
                        }}
                        onFocus={() => handleFocus("mobile_number")}
                        value={Phone}
                      />
                    </div>
                  </div>

                  <span className="fc-header">
                    Bank Details
                    {/* {transparentInfoIcon({
                      marginLeft: "1vw",
                      cursor: "pointer",
                      verticalAlign: "middle",
                    })} */}
                  </span>

                  <div className="bank_detail">
                    {Bank?.fields?.map((item, idx) => renderElement(item, idx))}
                  </div>
                </React.Fragment>
              )}

              {!ShowBank && (
                <div className="noBank">
                  Your country's bank is currently not supported. Please Contact
                  us for further query.
                </div>
              )}

              <div className="recaptcha" id="dev_recaptcha">
                <ReCAPTCHAV2
                  data-type="image"
                  sitekey={process.env.REACT_APP_SITE_KEY}
                  onChange={(value) => {
                    setcaptchaValue(value);
                  }}
                  // size="compact"
                />
                {/* {true < 850 && (
              <ReCAPTCHAV2
                data-type="image"
                sitekey="6LcaF0IbAAAAAGhlDZbAFM0mOEI3GOKFr1ao9N9_"
                // onChange={onChange}
                size="compact"
              />
            )}
            {false > 850 && (
              <ReCAPTCHAV2
                data-type="image"
                sitekey="6LcaF0IbAAAAAGhlDZbAFM0mOEI3GOKFr1ao9N9_"
                // onChange={onChange}
                size="normal"
              />
            )} */}
              </div>
            </div>
          </Scrollbars>

          <div className="_tos">
            <Radio
              id="checkbox_002"
              checked={TOS}
              onClick={() => {
                setTOS(!TOS);
              }}
              className="adjust_cb"
            />
            <p>
              Creating an account means you’re okay with our{" "}
              <span>
                Terms of Service,
                <br /> Privacy Policy,
              </span>{" "}
              and our default <span>Notification Settings</span>.
            </p>
          </div>
          <Button
            onClick={postData}
            // onClick={validateBankData}

            style={{
              display: "block",
              margin: "2vw auto",
              marginBottom: "0",
              width: "90%",
            }}
            type="gradient"
            bg
            name="Submit"
          />
        </div>
      </FormCard>
      <AnimatedModal
        modalOpen={ShowAlert}
        // modalOpen={true}
        handleClose={() => {
          setShowAlert(false);
          if (msg.errorText === "Registered as developer successfully!") {
            clearTimeout(timeout);
            encryptStorage.removeItem("DDATA");
            history.push("/");
          }
        }}
        type={msg.type}
        errorHeader={msg.header}
        errorText={msg.errorText}
        // timeout={5000}
        alwayOpen={true}
      />
      {LoadingScreen && <Loading type={"transparent"} text={"Loading"} />}
    </div>
  );
}

export const SocialInput = ({ icon, onDelete, onChange, value }) => {
  return (
    <div className="social-input">
      <div className="social_icon">{icon}</div>
      <input
        id="abc"
        type="text"
        className="input_style"
        value={value}
        onChange={onChange}
      />
      <div className="close_" onClick={onDelete}>
        {add()}
      </div>
    </div>
  );
};

export const social_link = [
  {
    name: "Github",
    icon: (
      <svg
        width="256px"
        height="256px"
        viewBox="0 -3 256 256"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid"
      >
        <g>
          <path
            d="M128.00106,0 C57.3172926,0 0,57.3066942 0,128.00106 C0,184.555281 36.6761997,232.535542 87.534937,249.460899 C93.9320223,250.645779 96.280588,246.684165 96.280588,243.303333 C96.280588,240.251045 96.1618878,230.167899 96.106777,219.472176 C60.4967585,227.215235 52.9826207,204.369712 52.9826207,204.369712 C47.1599584,189.574598 38.770408,185.640538 38.770408,185.640538 C27.1568785,177.696113 39.6458206,177.859325 39.6458206,177.859325 C52.4993419,178.762293 59.267365,191.04987 59.267365,191.04987 C70.6837675,210.618423 89.2115753,204.961093 96.5158685,201.690482 C97.6647155,193.417512 100.981959,187.77078 104.642583,184.574357 C76.211799,181.33766 46.324819,170.362144 46.324819,121.315702 C46.324819,107.340889 51.3250588,95.9223682 59.5132437,86.9583937 C58.1842268,83.7344152 53.8029229,70.715562 60.7532354,53.0843636 C60.7532354,53.0843636 71.5019501,49.6441813 95.9626412,66.2049595 C106.172967,63.368876 117.123047,61.9465949 128.00106,61.8978432 C138.879073,61.9465949 149.837632,63.368876 160.067033,66.2049595 C184.49805,49.6441813 195.231926,53.0843636 195.231926,53.0843636 C202.199197,70.715562 197.815773,83.7344152 196.486756,86.9583937 C204.694018,95.9223682 209.660343,107.340889 209.660343,121.315702 C209.660343,170.478725 179.716133,181.303747 151.213281,184.472614 C155.80443,188.444828 159.895342,196.234518 159.895342,208.176593 C159.895342,225.303317 159.746968,239.087361 159.746968,243.303333 C159.746968,246.709601 162.05102,250.70089 168.53925,249.443941 C219.370432,232.499507 256,184.536204 256,128.00106 C256,57.3066942 198.691187,0 128.00106,0 Z M47.9405593,182.340212 C47.6586465,182.976105 46.6581745,183.166873 45.7467277,182.730227 C44.8183235,182.312656 44.2968914,181.445722 44.5978808,180.80771 C44.8734344,180.152739 45.876026,179.97045 46.8023103,180.409216 C47.7328342,180.826786 48.2627451,181.702199 47.9405593,182.340212 Z M54.2367892,187.958254 C53.6263318,188.524199 52.4329723,188.261363 51.6232682,187.366874 C50.7860088,186.474504 50.6291553,185.281144 51.2480912,184.70672 C51.8776254,184.140775 53.0349512,184.405731 53.8743302,185.298101 C54.7115892,186.201069 54.8748019,187.38595 54.2367892,187.958254 Z M58.5562413,195.146347 C57.7719732,195.691096 56.4895886,195.180261 55.6968417,194.042013 C54.9125733,192.903764 54.9125733,191.538713 55.713799,190.991845 C56.5086651,190.444977 57.7719732,190.936735 58.5753181,192.066505 C59.3574669,193.22383 59.3574669,194.58888 58.5562413,195.146347 Z M65.8613592,203.471174 C65.1597571,204.244846 63.6654083,204.03712 62.5716717,202.981538 C61.4524999,201.94927 61.1409122,200.484596 61.8446341,199.710926 C62.5547146,198.935137 64.0575422,199.15346 65.1597571,200.200564 C66.2704506,201.230712 66.6095936,202.705984 65.8613592,203.471174 Z M75.3025151,206.281542 C74.9930474,207.284134 73.553809,207.739857 72.1039724,207.313809 C70.6562556,206.875043 69.7087748,205.700761 70.0012857,204.687571 C70.302275,203.678621 71.7478721,203.20382 73.2083069,203.659543 C74.6539041,204.09619 75.6035048,205.261994 75.3025151,206.281542 Z M86.046947,207.473627 C86.0829806,208.529209 84.8535871,209.404622 83.3316829,209.4237 C81.8013,209.457614 80.563428,208.603398 80.5464708,207.564772 C80.5464708,206.498591 81.7483088,205.631657 83.2786917,205.606221 C84.8005962,205.576546 86.046947,206.424403 86.046947,207.473627 Z M96.6021471,207.069023 C96.7844366,208.099171 95.7267341,209.156872 94.215428,209.438785 C92.7295577,209.710099 91.3539086,209.074206 91.1652603,208.052538 C90.9808515,206.996955 92.0576306,205.939253 93.5413813,205.66582 C95.054807,205.402984 96.4092596,206.021919 96.6021471,207.069023 Z"
            fill="#161614"
          />
        </g>
      </svg>
    ),
    link: "",
    isOpen: true,
  },
  {
    name: "LinkedIn",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-label="LinkedIn"
        role="img"
        viewBox="0 0 512 512"
        fill="#fff"
      >
        <rect width={512} height={512} rx="15%" fill="#0077b5" />
        <circle cx={142} cy={138} r={37} />
        <path stroke="#fff" strokeWidth={66} d="M244 194v198M142 194v198" />
        <path d="M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32" />
      </svg>
    ),
    link: "",
    isOpen: false,
  },
  {
    name: "Twitter",
    icon: (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#1DA1F2"
          fillRule="evenodd"
          d="M24,4.3086 C23.117,4.7006 22.168,4.9646 21.172,5.0836 C22.188,4.4746 22.969,3.5096 23.337,2.3596 C22.386,2.9246 21.332,3.3336 20.21,3.5556 C19.312,2.5976 18.032,1.9996 16.616,1.9996 C13.897,1.9996 11.692,4.2046 11.692,6.9236 C11.692,7.3096 11.736,7.6856 11.82,8.0456 C7.728,7.8406 4.099,5.8806 1.671,2.9006 C1.247,3.6286 1.004,4.4736 1.004,5.3766 C1.004,7.0846 1.873,8.5926 3.195,9.4756 C2.388,9.4486 1.628,9.2276 0.964,8.8596 L0.964,8.9206 C0.964,11.3066 2.661,13.2966 4.914,13.7486 C4.501,13.8626 4.065,13.9216 3.617,13.9216 C3.299,13.9216 2.991,13.8906 2.69,13.8336 C3.317,15.7896 5.135,17.2136 7.29,17.2536 C5.604,18.5736 3.481,19.3606 1.175,19.3606 C0.777,19.3606 0.385,19.3376 0,19.2926 C2.179,20.6886 4.767,21.5046 7.548,21.5046 C16.605,21.5046 21.557,14.0016 21.557,7.4946 C21.557,7.2816 21.552,7.0696 21.543,6.8586 C22.505,6.1636 23.34,5.2966 24,4.3086"
        />
      </svg>
    ),
    link: "",
    isOpen: false,
  },
  {
    name: "Facebook",
    icon: (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#3B5998"
          fillRule="evenodd"
          d="M9.94474914,22 L9.94474914,13.1657526 L7,13.1657526 L7,9.48481614 L9.94474914,9.48481614 L9.94474914,6.54006699 C9.94474914,3.49740494 11.8713513,2 14.5856738,2 C15.8857805,2 17.0033128,2.09717672 17.3287076,2.13987558 L17.3287076,5.32020466 L15.4462767,5.32094085 C13.9702212,5.32094085 13.6256856,6.02252733 13.6256856,7.05171716 L13.6256856,9.48481614 L17.306622,9.48481614 L16.5704347,13.1657526 L13.6256856,13.1657526 L13.6845806,22"
        />
      </svg>
    ),
    link: "",
    isOpen: false,
  },
  {
    name: "Instagram",
    icon: (
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 551.034 551.034"
        style={{
          enableBackground: "new 0 0 551.034 551.034",
        }}
        xmlSpace="preserve"
      >
        <g id="XMLID_13_">
          <linearGradient
            id="XMLID_2_"
            gradientUnits="userSpaceOnUse"
            x1={275.517}
            y1={4.5714}
            x2={275.517}
            y2={549.7202}
            gradientTransform="matrix(1 0 0 -1 0 554)"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#E09B3D",
              }}
            />
            <stop
              offset={0.3}
              style={{
                stopColor: "#C74C4D",
              }}
            />
            <stop
              offset={0.6}
              style={{
                stopColor: "#C21975",
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#7024C4",
              }}
            />
          </linearGradient>
          <path
            id="XMLID_17_"
            style={{
              fill: "url(#XMLID_2_)",
            }}
            d="M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
          />
          <linearGradient
            id="XMLID_3_"
            gradientUnits="userSpaceOnUse"
            x1={275.517}
            y1={4.5714}
            x2={275.517}
            y2={549.7202}
            gradientTransform="matrix(1 0 0 -1 0 554)"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#E09B3D",
              }}
            />
            <stop
              offset={0.3}
              style={{
                stopColor: "#C74C4D",
              }}
            />
            <stop
              offset={0.6}
              style={{
                stopColor: "#C21975",
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#7024C4",
              }}
            />
          </linearGradient>
          <path
            id="XMLID_81_"
            style={{
              fill: "url(#XMLID_3_)",
            }}
            d="M275.517,133C196.933,133,133,196.933,133,275.516 s63.933,142.517,142.517,142.517S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6 c-48.095,0-87.083-38.988-87.083-87.083s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083 C362.6,323.611,323.611,362.6,275.517,362.6z"
          />
          <linearGradient
            id="XMLID_4_"
            gradientUnits="userSpaceOnUse"
            x1={418.306}
            y1={4.5714}
            x2={418.306}
            y2={549.7202}
            gradientTransform="matrix(1 0 0 -1 0 554)"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#E09B3D",
              }}
            />
            <stop
              offset={0.3}
              style={{
                stopColor: "#C74C4D",
              }}
            />
            <stop
              offset={0.6}
              style={{
                stopColor: "#C21975",
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#7024C4",
              }}
            />
          </linearGradient>
          <circle
            id="XMLID_83_"
            style={{
              fill: "url(#XMLID_4_)",
            }}
            cx={418.306}
            cy={134.072}
            r={34.149}
          />
        </g>
      </svg>
    ),
    link: "",
    isOpen: false,
  },
  {
    name: "YouTube",
    icon: (
      <svg
        width="256px"
        height="256px"
        viewBox="0 -38 256 256"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid"
      >
        <g>
          <path
            d="M250.346231,28.0746923 C247.358133,17.0320558 238.732098,8.40602109 227.689461,5.41792308 C207.823743,0 127.868333,0 127.868333,0 C127.868333,0 47.9129229,0.164179487 28.0472049,5.58210256 C17.0045684,8.57020058 8.37853373,17.1962353 5.39043571,28.2388718 C-0.618533519,63.5374615 -2.94988224,117.322662 5.5546152,151.209308 C8.54271322,162.251944 17.1687479,170.877979 28.2113844,173.866077 C48.0771024,179.284 128.032513,179.284 128.032513,179.284 C128.032513,179.284 207.987923,179.284 227.853641,173.866077 C238.896277,170.877979 247.522312,162.251944 250.51041,151.209308 C256.847738,115.861464 258.801474,62.1091 250.346231,28.0746923 Z"
            fill="#FF0000"
          />
          <polygon
            fill="#FFFFFF"
            points="102.420513 128.06 168.749025 89.642 102.420513 51.224"
          />
        </g>
      </svg>
    ),
    link: "",
    isOpen: false,
  },
];

export const add = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      d="M12,22 L12,2 M2,12 L22,12"
    />
  </svg>
);

// let dict = {
//   country: "India",
//   fields: [
//     {
//       name: "bank_name",
//       required: true,
//       type: "string",
//       options: [],
//     },
//     {
//       name: "branch_name",
//       required: true,
//       type: "string",
//       options: [],
//     },
//     {
//       name: "ifsc_code",
//       required: true,
//       type: "string",
//       options: [],
//     },
//     {
//       name: "account_number",
//       required: true,
//       type: "number",
//       options: [],
//     },
//     {
//       name: "account_type",
//       required: true,
//       type: "dropdown",
//       options: ["Savings", "Current"],
//     },
//   ],
// };
